<template>
    <div>
        <div class="bar"></div>
        <div class="tip">企业版的功能和权益将会不断扩充，首选推荐企业版四季度版本</div>
        <div class="white">
            <div class="whiteText1">您已成功兑换吉林一号影像切片套件</div>
            <div class="whiteText2">如有疑问请联系指派给您套件兑换码的代理商</div>
            <div class="grey"></div>
            <div class="greyContent">
                <div class="greyText1">兑换单编号：</div>
                <div class="greyText2">{{id}}</div>
                <div class="greyText1" style="top: 96px;">兑换时间：</div>
                <div class="greyText2" style="top: 96px;">{{time}}</div>
                <div class="greyText1" style="top: 146px;">套件版本：</div>
                <div class="greyText2" style="top: 146px;">{{repositorySubName}}</div>
                <div class="greyText1" style="top: 196px;">兑换码：</div>
                <div class="greyText2" style="top: 196px;">{{redemptionCode}} </div>
                <div class="greyText1" style="top: 246px;">代理商联系人：</div>
                <div class="greyText2" style="top: 246px;">{{agentName}}</div>
                <div class="greyButton" @click="goviewMapSource()">立即看图</div>
                <div class="greyButton" style="left: 650px;" @click="$router.push('/MyRSservices');">查看套件明细</div>
            </div>
        </div>
       
    </div>
</template>

<script>
export default {
    name:"ProcessRep",
    data(){
        return{
            id:"",
            time:"",
            repositorySubName:"",
            repositoryId:"",
            redemptionCode:"",
            agentName:"北京航天世景信息技术有限公司",
        }
    },
    methods:{
        getKey() {
            return localStorage.getItem("token");
        },
        getOrderData(){
           this.id = this.$route.query.id;
           this.time =this.$route.query.createTime
           this.repositoryId =this.$route.query.repositoryId
           this.redemptionCode = this.$route.query.redemptionCode
           this.agentName = this.$route.query.agentName
           this.repositorySubName = this.$route.query.repositorySubName
        },
        goviewMapSource(){
            this.$router.push("/viewMapSource");  
        },
        toPageTop(){
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant",
            });
        },
    },
    mounted(){
        this.toPageTop()
        this.getOrderData()
    }

}
</script>

<style scoped>
.bar{
    position: relative;
    width: 100%;
    height: 76px;
    background-color: #fff;
}
.tip{
    position: relative;
    width: 100%;
    height: 76px;
    background-color: #F5F5F6;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 76px;
    text-align: center;
}
.white{
    position: relative;
    width: 1280px;
    height: 1000px;
    margin-left: calc(50% - 640px);
    background-color: #fff;
    
}
.whiteText1{
    position: absolute;
    top: 75px;
    width: 500px;
    left:calc(50% - 250px);
    height: 42px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 42px;
    text-align: center;
}
.whiteText2{
    position: absolute;
    top: 142px;
    left:calc(50% - 400px);
    width: 800px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 22px;
    text-align: center;
}
.grey{
    position: absolute;
    top: 214px;
    width: 1280px;
    height: 400px;
    background: rgba(245,245,246,0.1);
    opacity: 0.15;
    border-radius: 16px;
}
.greyContent{
    position: absolute;
    top: 214px;
    width: 1280px;
    height: 416px;
    background: transparent;
    border-radius: 16px;
}
.greyText1{
    position: absolute;
    top: 46px;
    right: 1065px;
    width: 200px;
    height: 30px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
    line-height: 30px;
    text-align: right;

}
.greyText2{
    position: absolute;
    top: 46px;
    left: 225px;
    width: 768px;
    height: 30px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #979797;
    line-height: 30px;
}
.greyInput{
    position: absolute;
    top: 241px;
    left: 225px;
    width: 800px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 8px;
    border: 1px solid #979797;
}
.greyText3{
    position: absolute;
    top: 250px;
    right: 213px;
    width: 40px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 22px;
    text-align: right;
    cursor: pointer;
}
.greyText4{
position: absolute;
top: 286px;
    left: 225px;
    width: 768px;
    height: 30px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: red;
    line-height: 30px;
}
.greyButton{
    position: absolute;
    top: 324px;
    left: 502px;
    width: 128px;
    height: 40px;
    border-radius: 8px;
    border: 1px solid #3A3A3A;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3A3A3A;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
}
.inputContent{
    top: 5px;
    left: 5px;
  position: absolute;
  width: 768px;
height: 30px;
font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #3a3a3a;
line-height: 30px;  
position: absolute;
  border: none;
  background: none;
  outline: none;
  padding: 0;
}
.shadow {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.shadowContent{
    position: fixed;
    top: calc(50% - 200px);
    left: calc(50% - 400px);
    width: 800px;
    height: 400px;
    background: #FFFFFF;
    border-radius: 12px;
}
.shadowContent1{
    position: fixed;
    top: calc(50% - 150px);
    left: calc(50% - 400px);
    width: 800px;
    height: 300px;
    background: #FFFFFF;
    border-radius: 12px;
}
.shadowClose{
position: absolute;
width: 40px;
height: 40px;
top: 0px;
right: -55px;
cursor: pointer;
}
.shadowButton{
    position: absolute;
    top: 175px;
    left: calc(50% - 75px);
    width: 150px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 6px;
    border: 1px solid #3A3A3A;
    cursor: pointer;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 40px;
    text-align: center;
}
.shadowText1{
    position: absolute;
    top: 50px;
    left: calc(50% - 400px);
    width: 800px;
height: 25px;
font-size: 18px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 25px;
text-align: center;
}
.shadowIcon{
    position: absolute;
    top: 124px;
    left: 90px;
    width: 16px;
    height: 16px;
    cursor: pointer;
}
.shadowText2{
    position: absolute;
    top: 121px;
    left: 118px;
    width: 700px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #777777;
    line-height: 22px;
}
.shadowText3{
    position: absolute;
    top: 100px;
    left: calc(50% - 400px);
    width: 800px;
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 25px;
    text-align: center;
}
.shadowOther{
    position: absolute;
    top: 239px;
    left: 194px;
    width: 500px;
height: 40px;
background: #FFFFFF;
border-radius: 6px;
border: 1px solid #979797;
}
.shadowOtherInput{
    top: 5px;
    left: 5px;
  position: absolute;
  width: 450px;
height: 30px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #000;
line-height: 30px;  
position: absolute;
  border: none;
  background: none;
  outline: none;
  padding: 0;
}
.shadowButton1{
    position: absolute;
    top: 307px;
    left: 244px;
    width: 150px;
    height: 40px;
    background: #1E81EB;
    border-radius: 6px;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    }
    .shadowButton2{
        position: absolute;
        top: 307px;
        left: 406px;
        width: 150px;
    height: 40px;
    background: #FFFFFF;
    border-radius: 6px;
    border: 1px solid #1E81EB;
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 500;
    color: #1E81EB;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    }
</style>